import CNumberField from "crqlar-react-common/dist/components/CNumberField";
import * as React from "react";

interface BorderRadiusFieldProps {
    value: number;
    onChange: (value: number) => void;
}

const BorderRadiusField = ({value, onChange}: BorderRadiusFieldProps) => (
    <CNumberField
        value={value}
        onChange={(v) => v !== null && onChange(v)}
        min={0}
        max={50}
        sx={{width: 200}}
    />
)

export default BorderRadiusField
